'use client'

import { memo } from 'react'
import { IconTrashX } from '@tabler/icons-react'
import clsx from 'clsx'

import { AppliedDiscountCode } from 'modules/benefitCodes'
import Button from 'shared/ui/Button'
import type { ButtonProps } from 'shared/ui/Button/Button'
import { addTestId } from 'shared/utils/tests'

import styles from './CartActiveDiscountCode.module.scss'

interface CartActiveDiscountCodeProps {
  code: AppliedDiscountCode
  handleRemoveCode: () => void
}

const ActiveCodeRemoveButton = ({ className, ...props }: ButtonProps) => (
  <Button
    className={clsx(styles.activeCodeRemoveButton, className)}
    {...props}
  />
)

const CartActiveDiscountCode = memo(
  ({ code, handleRemoveCode }: CartActiveDiscountCodeProps) => (
    <div className={styles.activeCodeWrapper}>
      <div className={styles.activeCodeLabel}>
        <p className={styles.activeCodeTitle}>
          <span
            {...addTestId('active-codes-badge')}
            dangerouslySetInnerHTML={{
              __html: `${code.value.formatted} zniżki`
            }}
          />
        </p>
        <div className={styles.onlyDesktopContent}>
          {code.minimumOrderValue && (
            <p>
              Przy zakupach za min.{' '}
              <span
                dangerouslySetInnerHTML={{
                  __html: `${code.minimumOrderValue?.formatted}`
                }}
              />
            </p>
          )}
        </div>
      </div>
      <ActiveCodeRemoveButton
        {...addTestId('active-codes-remove-button')}
        variant='neutralText'
        size='small'
        onClick={handleRemoveCode}
        startIcon={<IconTrashX />}
      >
        Usuń
      </ActiveCodeRemoveButton>
    </div>
  )
)

export default CartActiveDiscountCode
